import { render, staticRenderFns } from "./RatingMenu.vue?vue&type=template&id=3079b67e&scoped=true&"
import script from "./RatingMenu.vue?vue&type=script&lang=js&"
export * from "./RatingMenu.vue?vue&type=script&lang=js&"
import style0 from "./RatingMenu.vue?vue&type=style&index=0&id=3079b67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079b67e",
  null
  
)

export default component.exports